(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('cancel', (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement)) return;
    if (!dialog.closest('#filters-drawer')) return;
    if (!dialog.closest('results-list[data-rn-mobile-collection]')) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const component = dialog.closest('dialog-component');
    if (typeof component?.closeDialog !== 'function') return;
    event.preventDefault();
    component.closeDialog();
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rn-stock-alternatives"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rn-stock-alternatives')) {
    customElements.define('rn-stock-alternatives', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.rn-stock-alternatives__list');
        this.items = Array.from(this.list?.children || []);
        this.button = this.querySelector('.rn-stock-alternatives__toggle');
        if (!this.list || !this.button || !window.ResizeObserver) return;
        this.expanded = false;
        this.onToggle = () => {
          const firstNew = this.items[this.limit]?.querySelector('a');
          const previousTop = this.button.getBoundingClientRect().top;
          this.expanded = !this.expanded;
          this.update();
          if (this.expanded && firstNew) {
            firstNew.focus({ preventScroll: true });
            firstNew.scrollIntoView({ block: 'nearest', behavior: 'instant' });
          } else {
            this.button.focus({ preventScroll: true });
            window.scrollBy({ top: this.button.getBoundingClientRect().top - previousTop, behavior: 'instant' });
          }
        };
        this.button.addEventListener('click', this.onToggle);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this);
        this.update();
      }
      update() {
        try {
          const columns = getComputedStyle(this.list).gridTemplateColumns.trim().split(/\s+/).length;
          this.limit = columns > 1 ? 3 : 2;
          const hasMore = this.items.length > this.limit;
          if (!hasMore) this.expanded = false;
          this.items.forEach((item, index) => {
            const hide = !this.expanded && index >= this.limit;
            if (hide && item.contains(document.activeElement)) this.button.focus({ preventScroll: true });
            item.hidden = hide;
          });
          this.button.hidden = !hasMore;
          this.button.setAttribute('aria-expanded', String(this.expanded));
          this.button.textContent = this.expanded ? this.button.dataset.less : this.button.dataset.more;
        } catch {
          this.items.forEach(item => { item.hidden = false; });
          this.button.hidden = true;
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.onToggle);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
